import { useQueryClient } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'
import { useCourseAssignmentMutation } from './useCourseAssignmentMutation'

const saveResultEdits = async ({ periodId, versionId, moves }) => {
  const client = await getApi('schools', { authenticated: true, version: 5 })
  const { data } = await client.post(
    `/current-organization/course-assignment/periods/${periodId}/results/${versionId}/edits`,
    { moves }
  )
  return data
}

export const useSaveResultEdits = () => {
  const queryClient = useQueryClient()

  return useCourseAssignmentMutation({
    mutationFn: saveResultEdits,
    hookName: 'useSaveResultEdits',
    errorMessage: 'Error saving course assignment result edits',
    shouldReportError: (error) => error?.response?.status !== 400,
    onSuccess: (_data, { periodId }) => {
      queryClient.invalidateQueries({ queryKey: ['courseAssignmentResultVersions', periodId] })
    }
  })
}
